import Chart from 'chart.js/auto';

const TenantActivityChart = {
  chart: null,

  mounted() {
    console.log('TenantActivityChart mounted');
    this.initChart();
  },

  updated() {
    console.log('TenantActivityChart updated');
    this.updateChart();
  },

  destroyed() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },

  initChart() {
    try {
      const ctx = this.el.getContext('2d');
      
      const activeCount = parseInt(this.el.dataset.active) || 0;
      const inactiveCount = parseInt(this.el.dataset.inactive) || 0;
      const totalCount = activeCount + inactiveCount;

      if (totalCount === 0) {
        console.log('No data for tenant activity chart');
        return;
      }

      this.chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['Active Tenants', 'Inactive Tenants'],
          datasets: [{
            data: [activeCount, inactiveCount],
            backgroundColor: [
              '#10B981',
              '#E5E7EB', 
            ],
            borderColor: [
              '#059669', 
              '#D1D5DB',
            ],
            borderWidth: 2,
            hoverBackgroundColor: [
              '#059669', 
              '#D1D5DB',
            ],
            hoverBorderWidth: 3
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                color: '#374151', 
                font: { 
                  size: 13,
                  weight: '500'
                },
                padding: 15,
                usePointStyle: true,
                pointStyle: 'circle'
              }
            },
            tooltip: {
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              titleColor: '#fff',
              bodyColor: '#fff',
              padding: 12,
              cornerRadius: 8,
              displayColors: true,
              callbacks: {
                label: function(context) {
                  const label = context.label || '';
                  const value = context.parsed;
                  const percentage = ((value / totalCount) * 100).toFixed(1);
                  return `${label}: ${value} (${percentage}%)`;
                }
              }
            }
          },
          cutout: '60%', 
        }
      });

      console.log('TenantActivityChart initialized successfully');
    } catch (error) {
      console.error('Error initializing TenantActivityChart:', error);
    }
  },

  updateChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    this.initChart();
  }
};

export default TenantActivityChart;